import * as React from "react";
import { useTableKindId } from "../../newcomponents/table/data/useTableKindId";
import { useTableItemQueryData } from "../../newcomponents/table/data/useTableItemQueryData";
import { Table } from "../../newcomponents/table/table";
import { TableNewItemButton } from "../../newcomponents/table/components/tableNewButton";
import { TableExportButton } from "../../newcomponents/table/components/tableExportButton";
import { CustomTableCPLNQuery } from "../../newcomponents/table/components/TableCplnQuery";
import { NameDescriptionColumn } from "../../newcomponents/table/columns/wellKnown/nameDescriptionColumn";
import { TagsColumn } from "../../newcomponents/table/columns/wellKnown/tagsColumn";
import { LastModifiedColumn } from "../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { CreatedColumn } from "../../newcomponents/table/columns/wellKnown/createdColumn";
import { TableHeaderRefreshButton } from "../../newcomponents/table/components/RefreshButton";
import { OriginColumn } from "../../newcomponents/table/columns/wellKnown/originColumn";
import { AuditContext } from "../../schema/types/auditctx/entity";
import { AuditContextTableItem, getAuditContextTableItem } from "../../mst/kinds/auditctx.helpers";
import { useColumnsWithTagColumns } from "../../newcomponents/table/columns/tagColumns/useColumnsWithTagColumns";

export const AuditContextList: React.FC = () => {
  const { kind, id } = useTableKindId("auditctx", "auditctx-list");
  const qData = useTableItemQueryData<AuditContext>(kind, {});
  const columns = useColumnsWithTagColumns<AuditContextTableItem>(
    [NameDescriptionColumn(), OriginColumn(), TagsColumn(), CreatedColumn(), LastModifiedColumn()],
    kind,
  );

  const auditContextTableItems: AuditContextTableItem[] = qData.visibleItems.map((auditctx) =>
    getAuditContextTableItem({ item: auditctx }),
  );

  return (
    <Table<AuditContextTableItem>
      title={"Audit Contexts"}
      data={auditContextTableItems}
      tableId={id}
      headerRenderer={(table) => {
        const currentVisibleItemLinks = table.getRowModel().rows.map((row) => row.original.selfLink);
        return (
          <>
            <TableNewItemButton kind={kind} />
            <TableExportButton selfLinks={currentVisibleItemLinks} kind={kind} />
            <TableHeaderRefreshButton onClick={qData.refetch} />
            <CustomTableCPLNQuery
              tableId={id}
              kind={kind}
              onQuery={qData.setCplnQuery}
              isLoading={qData.isLoading}
            />
          </>
        );
      }}
      enableFilter
      isLoading={qData.isLoading}
      onSortChange={qData.setSort}
      onSearchChange={qData.setSearch}
      isLoadingMore={qData.isLoadingMore}
      hasMore={qData.hasMore}
      onLoadMore={qData.fetchNextPage}
      columns={columns}
    />
  );
};
